module.exports = __webpack_public_path__ + "static/media/ma_ageOfTheGods.1bffa76f.png";